import theme from '../../theme';

const styles = {
  wrap: {
    pt: 2,
    pb: 1,
    a: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 700,
    },
  },
};

export default styles;
